import React from 'react'
import { Button } from '../../ui/button' // Assuming your Button component path
import { XCircle } from 'lucide-react' // Importing an icon for a close button

function PaymentDisclaimerModal({ plan, onConfirm, onClose, isYearlyBilling }) {
  if (!plan) return null

  // Determine which price details to display based on isYearlyBilling prop
  const selectedPriceDetails = isYearlyBilling ? plan.price.yearly : plan.price.monthly

  // Handle cases where price details might be missing for a period (e.g., Enterprise has no fixed price)
  const displayAmount = selectedPriceDetails
    ? (selectedPriceDetails.amount / 100).toFixed(2)
    : 'N/A'
  const displayCurrency = selectedPriceDetails ? selectedPriceDetails.currency : ''
  const displayPeriod = isYearlyBilling ? 'year' : 'month'

  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center z-50 p-4"
      onClick={onClose} // Allows closing by clicking outside the modal
    >
      <div
        className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-auto relative transform transition-all duration-300 scale-100 opacity-100"
        onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close modal"
        >
          <XCircle className="w-6 h-6" />
        </button>

        <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Confirm Your Plan Selection
        </h3>

        <div className="border-t border-b border-gray-200 py-4 mb-6">
          <p className="text-gray-700 text-lg text-center mb-2">
            You've chosen the{' '}
            <span className="font-extrabold text-heading-primary">{plan.name}</span>
          </p>
          {plan.tier === 'enterprise' ? (
            <p className="text-4xl font-extrabold text-center text-heading-primary">
              {displayCurrency}
              {displayAmount}
              <span className="text-base text-gray-500 font-normal">/{displayPeriod}</span>
            </p>
          ) : (
            <p className="text-4xl font-extrabold text-center text-heading-primary">
              {displayCurrency}
              {displayAmount}
              <span className="text-base text-gray-500 font-normal">/{displayPeriod}</span>
            </p>
          )}
        </div>

        <p className="text-red-700 font-semibold text-center text-lg mb-6 p-2 bg-red-50 rounded-md border border-red-200">
          <span className="font-extrabold">Important:</span> Your payment will be automatically
          deducted from your **default payment method** on file.
        </p>

        <p className="text-gray-600 text-sm text-center mb-6">
          By confirming, you agree to the immediate upgrade and billing for the selected plan.
        </p>

        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 sm:flex-none px-6 py-3 text-lg border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="flex-1 sm:flex-none bg-heading-primary hover:bg-[#643d73] text-white font-semibold px-6 py-3 text-lg"
          >
            Confirm & Upgrade
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PaymentDisclaimerModal
